import { Col, Collapse, Form as AntForm, Row } from "antd";
import type { FormInstance } from "antd/es/form/Form";
import { useForm } from "antd/es/form/Form";
import type { FC, PropsWithChildren, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { ActionBar } from "../ActionBar/ActionBar";
import { ResetButton } from "../FeatureButtons/ResetButton";
import { SearchButton } from "../FeatureButtons/SearchButton";

/**
 * Search Form properties
 * */
type SearchFormProps = {
    searchCallback?: Function;
    onReset?: () => void;
    form?: FormInstance;
} & PropsWithChildren;

/**
 * Default component for the search form for the resource pages
 * */
export const SearchForm: FC<SearchFormProps> = ({ searchCallback, onReset, form: externalForm, children }) => {
    const [internalForm] = useForm();
    const form = externalForm || internalForm;
    const { Panel } = Collapse;
    const { t } = useTranslation();

    const onResetClicked = () => {
        form.resetFields();
        if (onReset) {
            onReset();
        } else if (searchCallback) {
            searchCallback({});
        }
    };

    const onSearchClicked = () => {
        if (searchCallback) {
            searchCallback(form.getFieldsValue());
        }
    };

    const wrapInCols = (nodes: ReactNode) =>
        Array.isArray(nodes) ? (
            nodes.map((child, i) => (
                <Col key={i} xs={24} sm={12} md={12} lg={6} xl={6}>
                    {child}
                </Col>
            ))
        ) : (
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                {nodes}
            </Col>
        );

    return (
        <Collapse>
            <Panel header={t("button.search")} key="search">
                <AntForm form={form} name="search" layout="vertical" autoComplete="off">
                    <Row gutter={[24, 1]}>{wrapInCols(children)}</Row>
                </AntForm>
                <ActionBar className="left">
                    <SearchButton isDisabled={false} callback={onSearchClicked} />
                    <ResetButton isDisabled={false} callback={onResetClicked} />
                </ActionBar>
            </Panel>
        </Collapse>
    );
};
